// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ConnectList_wrapper__3Xvas","component":"ConnectList_component__3wk9K","title":"ConnectList_title__1UTlc","button":"ConnectList_button__iY_2g"};